import React from 'react';
import { Link } from 'react-router-dom';

const Services = () => {
  return (
    <div className="services-page" style={{backgroundColor: 'var(--bg-dark)'}}>
      <div className="page-header" style={{backgroundImage: "url('https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80')"}}>
        <div className="page-header-overlay"></div>
        <div className="container page-header-content">
          <h1 className="fw-bold">Our Services</h1>
          <p className="description">Comprehensive Corporate & Fiduciary Solutions</p>
        </div>
      </div>

      <div className="container pb-5">
        <div className="row g-4">
          {/* Service 0 - Citizenship by Investment */}
          <div className="col-md-6 col-lg-4">
            <div className="card h-100 border-0 p-4">
              <div className="card-body">
                <div className="icon-box">
                   <i className="bi bi-passport fs-4"></i>
                </div>
                <h4 className="card-title fw-bold text-white" style={{fontFamily: 'var(--font-serif)'}}>Citizenship by Investment</h4>
                <p className="card-text text-muted mt-3">
                  Expert guidance through the St. Kitts and Nevis Citizenship by Investment Program, the oldest and most respected of its kind.
                </p>
                <ul className="list-unstyled small mt-3">
                    <li className="mb-2"><i className="bi bi-check2 text-accent me-2"></i>SISC Application Support</li>
                    <li className="mb-2"><i className="bi bi-check2 text-accent me-2"></i>Real Estate Investment</li>
                    <li className="mb-2"><i className="bi bi-check2 text-accent me-2"></i>Contribution Option</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Service 1 */}
          <div className="col-md-6 col-lg-4">
            <div className="card h-100 border-0 p-4">
              <div className="card-body">
                <div className="icon-box">
                   <i className="bi bi-building fs-4"></i>
                </div>
                <h4 className="card-title fw-bold text-white" style={{fontFamily: "var(--font-serif)"}}>LLC & IBC Formation</h4>
                <p className="card-text text-muted mt-3">
                  We handle the complete incorporation process for Nevis Limited Liability Companies (LLCs) and International Business Corporations (IBCs).
                </p>
                <ul className="list-unstyled small text-muted mt-3">
                    <li className="mb-2"><i className="bi bi-check2 text-accent me-2"></i>Rapid Incorporation</li>
                    <li className="mb-2"><i className="bi bi-check2 text-accent me-2"></i>Drafting Articles of Organization</li>
                    <li className="mb-2"><i className="bi bi-check2 text-accent me-2"></i>Operating Agreements</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Service 2 */}
          <div className="col-md-6 col-lg-4">
            <div className="card h-100 border-0 p-4">
              <div className="card-body">
                <div className="icon-box">
                   <i className="bi bi-bank2 fs-4"></i>
                </div>
                <h4 className="card-title fw-bold text-white" style={{fontFamily: "var(--font-serif)"}}>Trust Registrations</h4>
                <p className="card-text text-muted mt-3">
                  Establishment of International Exempt Trusts tailored for asset protection and estate planning under the Nevis International Exempt Trust Ordinance.
                </p>
                 <ul className="list-unstyled small text-muted mt-3">
                    <li className="mb-2"><i className="bi bi-check2 text-accent me-2"></i>Asset Protection Trusts</li>
                    <li className="mb-2"><i className="bi bi-check2 text-accent me-2"></i>Charitable Trusts</li>
                    <li className="mb-2"><i className="bi bi-check2 text-accent me-2"></i>Spendthrift Provisions</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Service 3 */}
          <div className="col-md-6 col-lg-4">
            <div className="card h-100 border-0 p-4">
              <div className="card-body">
                <div className="icon-box">
                   <i className="bi bi-person-check fs-4"></i>
                </div>
                <h4 className="card-title fw-bold text-white" style={{fontFamily: "var(--font-serif)"}}>Trustee & Nominee Services</h4>
                <p className="card-text text-muted mt-3">
                  Professional trustee appointments and nominee shareholder/director services to maintain privacy and ensure professional management.
                </p>
                 <ul className="list-unstyled small text-muted mt-3">
                    <li className="mb-2"><i className="bi bi-check2 text-accent me-2"></i>Professional Trusteeship</li>
                    <li className="mb-2"><i className="bi bi-check2 text-accent me-2"></i>Nominee Directors</li>
                    <li className="mb-2"><i className="bi bi-check2 text-accent me-2"></i>Nominee Shareholders</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Service 4 */}
          <div className="col-md-6 col-lg-4">
            <div className="card h-100 border-0 p-4">
              <div className="card-body">
                <div className="icon-box">
                   <i className="bi bi-geo-alt-fill fs-4"></i>
                </div>
                <h4 className="card-title fw-bold text-white" style={{fontFamily: "var(--font-serif)"}}>Registered Agent Services</h4>
                <p className="card-text text-muted mt-3">
                   Acting as your statutory local representative, receiving official correspondence and ensuring your entity remains in good standing.
                </p>
                 <ul className="list-unstyled small text-muted mt-3">
                    <li className="mb-2"><i className="bi bi-check2 text-accent me-2"></i>Compliance Monitoring</li>
                    <li className="mb-2"><i className="bi bi-check2 text-accent me-2"></i>Annual Renewals</li>
                    <li className="mb-2"><i className="bi bi-check2 text-accent me-2"></i>Local Office Address</li>
                </ul>
              </div>
            </div>
          </div>

           {/* Service 5 */}
           <div className="col-md-6 col-lg-4">
            <div className="card h-100 border-0 p-4">
              <div className="card-body">
                <div className="icon-box">
                   <i className="bi bi-briefcase-fill fs-4"></i>
                </div>
                <h4 className="card-title fw-bold text-white" style={{fontFamily: "var(--font-serif)"}}>Acquisitions</h4>
                <p className="card-text text-muted mt-3">
                   Strategic support for mergers and acquisitions involving Nevis entities, including due diligence and regulatory approval.
                </p>
                 <ul className="list-unstyled small text-muted mt-3">
                    <li className="mb-2"><i className="bi bi-check2 text-accent me-2"></i>Entity Due Diligence</li>
                    <li className="mb-2"><i className="bi bi-check2 text-accent me-2"></i>Transfer of Ownership</li>
                    <li className="mb-2"><i className="bi bi-check2 text-accent me-2"></i>Restructuring</li>
                </ul>
              </div>
            </div>
          </div>

        </div>

        <div className="mt-5 text-center">
             <div className="p-5 border border-secondary" style={{backgroundColor: 'var(--bg-panel)'}}>
                <h3 className="fw-bold text-white" style={{fontFamily: 'var(--font-serif)'}}>Ready to Secure Your Assets?</h3>
                <p className="text-muted mb-4">Contact our expert team today to discuss your specific requirements.</p>
                <Link to="/contact" className="btn btn-primary btn-lg px-5 fw-bold">Contact Us</Link>
             </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
